import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Slide, Fade } from "@mui/material";
import useWindowDimensions from "../../../utils/getHeightWidth";
import { changeTitle } from "../../../state/slices/header";
import CustomCards from "../../common/CustomCards/CustomCards";
import SubHeaderComponent from "../../common/RDTSubHeaderComponent/SubHeaderComponent";
import { ReportCardsData } from "../../../utils/cardsData";
import CustomColumns from "../../common/CustomColumns/CustomColumns";
import {
  delayTime,
  slideDirection,
  fadedelayTime,
} from "../../../utils/transitionEffectParams";
import reportsIcon from "./icons/icon.svg";
import ListHeading from "../../common/RDTListHeading/ListHeading";
import { RefreshReport } from "../../../utils/sidebar";
function ReportSection() {
  const dispatch = useDispatch();
  const [slideChecked, setSlideChecked] = useState(false);
  const { height } = useWindowDimensions();
  const [search, setSearch] = useState("");
  const [showLayoutSwitcher, setShowLayoutSwitcher] = useState("");
  const [filterBy, setFilterBy] = useState("");
  const reports = ReportCardsData();
  const [filteredReportData, setFilteredReportData] = useState(reports);
  const [viewlayoutSwitcher, setLayoutSwitcher] = useState(() => {
    return localStorage.getItem("viewType_Reports") || "cardsView";
  });
  const title_heading = useSelector((state) => state.header.title);
  const page_heading = "Reports";
  let datatable_height = height - 115 + "px";
  const UserColumns = [
    { label: "Database Reports", value: "database" },
    { label: "Server Reports", value: "server" },
    { label: "Web App Reports", value: "webAppReports" },
    { label: "User Reports", value: "userLoginReports" },
    { label: "Role Reports", value: "role" },
    { label: "Group Reports", value: "group" },
    { label: "Ticket Reports", value: "ticketsReport" },
    { label: "Password Rotation Reports", value: "password" },
    { label: "Client Credentials Reports", value: "clientCredentials" },
    { label: "Application Credentials Access Reports", value: "applicationCredentialsAccess" },
    { label: "Cloud Discovery Reports", value: "cloudDiscovery" },
  ];

  useEffect(() => {
    document.title = page_heading;
    setSlideChecked(true);
  }, []);

  useEffect(() => {
    dispatch(changeTitle("Reports"));
  }, []);

  useEffect(() => {
    const filteredData = reports.filter((item) => {
      const searchs = search.replaceAll(/[\\\*\(\)\+\[\?]/g, "").toLowerCase();

      const filterConditions = {
        database: () => item.title.toLowerCase().includes("database"),
        webAppReports: () => item.title.toLowerCase().includes("web"),
        ticketsReport: () => item.title.toLowerCase().includes("tickets"),
        server: () => item.title.toLowerCase().includes("server"),
        userLoginReports: () => item.title.toLowerCase().includes("user"),
        password: () => item.title.toLowerCase().includes("password"),
        role: () => item.title.toLowerCase().includes("role"),
        group: () => item.title.toLowerCase().includes("group"),
        clientCredentials: () => item.title.toLowerCase().includes("client credentials"),
        applicationCredentialsAccess: () => item.title.toLowerCase().includes("application credentials access"),
        cloudDiscovery: () => item.title.toLowerCase().includes("cloud discovery"),
      };

      if (filterBy === "" || filterBy === "all") {
        return Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchs)
        );
      }

      if (filterConditions[filterBy]) {
        return (
          filterConditions[filterBy]() &&
          Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchs)
          )
        );
      } else {
        return (
          item[filterBy] &&
          String(item[filterBy]).toLowerCase().includes(searchs)
        );
      }
    });
    setFilteredReportData(filteredData);
  }, [search, filterBy]);

  useEffect(() => {
    localStorage.setItem("viewType_Reports", viewlayoutSwitcher);
  }, [viewlayoutSwitcher]);
  const handleSearch = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    const handleRefreshData = () => {
      setFilteredReportData(reports);
      setFilterBy("all");
      setSearch("");
    };
    window.addEventListener(RefreshReport, handleRefreshData);
    return () => {
      window.removeEventListener(RefreshReport, handleRefreshData);
    };
  }, []);

  return (
    <>
      <Slide timeout={delayTime} direction={slideDirection} in={slideChecked}>
        <div>
          <Fade timeout={fadedelayTime} in={slideChecked}>
            <div>
              <div className="main_content_container p-3 mx-auto w-100">
                <div
                  className="position-relative bg-white overflow-auto"
                  style={{ height: `${datatable_height}` }}
                >
                  <div className="configure_mfa_heading border-bottom ">
                    <div className="pt-1 configure_mfa_heading  d-flex flex-row justify-content-between w-100">
                      <div className="d-flex align-items-center fw-300 ff-poppins pt-2 pb-1 text-wrap ms-4 ps-2">
                        <ListHeading
                          dataTableHeadingText="Reports"
                          dataTableHeadingIcon={reportsIcon}
                        />
                        <br />
                      </div>
                    </div>
                  </div>{" "}
                  <SubHeaderComponent
                    filterBy={filterBy}
                    setFilterBy={setFilterBy}
                    search={search}
                    handleSearch={handleSearch}
                    setSearch={setSearch}
                    filterOptions={UserColumns}
                    placeholder="Reports"
                    generalButton={true}
                    showLayoutSwitcher={setShowLayoutSwitcher}
                    viewLayoutSwitcher={viewlayoutSwitcher}
                    setLayoutSwitcher={setLayoutSwitcher}
                  />
                  <div
                    className="overflow-auto"
                    style={{ height: `${height - 250}px` }}
                  >
                    <div className="ps-4 ms-3 pe-5 pb-4 pt-4">
                      {!filteredReportData ||
                      filteredReportData.length === 0 ? (
                        <div className="d-flex pt-3 justify-content-center ff-pam no-records-message">
                          There are no records to display
                        </div>
                      ) : viewlayoutSwitcher === "cardsView" ? (
                        <CustomCards cardData={filteredReportData} />
                      ) : (
                        <CustomColumns columnData={filteredReportData} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </Slide>
    </>
  );
}
export default ReportSection;
